import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import figma from '../assets/figma.png';
import rails from '../assets/rails.png';
import git from '../assets/git.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import frontend from '../assets/frontend.png';
import backend from '../assets/backend.jpeg';
import railsApi from '../assets/railsApi.webp';
import fullstack from '../assets/fullstack.jpeg';
import neutral from '../assets/neutral.png';
import microverse from '../assets/microverse.png';
import cyw from '../assets/cyw.png';
import selma from '../assets/selma.jpeg';
import tarik from '../assets/tarik.jpeg';
import steve from '../assets/steve.jpeg';
import tobin from '../assets/tobin.jpeg';
import rachid from '../assets/rachid.jpeg';
import fatima from '../assets/fatima.jpeg';

import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';
import brightlogo from '../assets/bright_logo.png';

import bright from '../assets/bright.png';
import photo from '../assets/photo.png';
import sql from '../assets/sql.png';
import dravel from '../assets/dravel.png';
import covid from '../assets/covid.png';
import todo from '../assets/todo.png';
import bills from '../assets/bills.png';
import vision from '../assets/vision.png';
import board from '../assets/board.png';
import onisma from '../assets/onisma.png';
import onismaApi from '../assets/onismaApi.png';
import moverApi from '../assets/moverApi.png';
import cyweb from '../assets/cyweb.png';
import hagsyo from '../assets/hagsyo.jpeg';
import cywApi from '../assets/cywApi.png';
import neutralUI from '../assets/neutralUI.png';

export default {
  dravel,
  covid,
  todo,
  bills,
  vision,
  board,
  email,
  mobile,
  figma,
  rails,
  git,
  javascript,
  mu5,
  python,
  react,
  redux,
  sass,
  circle,
  logo,
  brightlogo,
  bright,
  photo,
  frontend,
  backend,
  railsApi,
  fullstack,
  sql,
  neutral,
  microverse,
  cyw,
  fatima,
  tobin,
  tarik,
  rachid,
  steve,
  selma,
  onisma,
  onismaApi,
  moverApi,
  cyweb,
  hagsyo,
  cywApi,
  neutralUI,
};
